import dayjs from "dayjs";
import { getLists } from "../../../api/ContactAPI";
import { getEmails, getLinkedinAccounts } from "../../../api/EmailAPI";
import { getQuickCampaigns } from "../../../api/StatsAPI";
import { getFirstPageUsers } from "../../../api/UserAPI";
import { useLanguage } from "../../../stores/LanguageStore";
import {
  useLeadsContainerStore,
  useLeadsStore,
} from "../../../stores/LeadsStore";
import { useProfileStore } from "../../../stores/UserStore";
import { useConfigStore, useModelsStore } from "../../../stores/ConfigStore";
import { getWorkflows } from "../../../api/WorkflowAPI";
import { getTags } from "../../../api/TagsAPI";
import { getDateStatus } from "../../../functions/utilFunctions";

export const status_list = () => {
  const lang = useLanguage.getState().language;
  return [
    {
      label: lang.components.status_selector.statuses.opener,
      value: "opener",
      defaultColor: "4c6ef5",
    },
    {
      label: lang.components.status_selector.statuses.clicker,
      value: "clicker",
      defaultColor: "fab005",
    },
    {
      label: lang.components.status_selector.statuses.answerer,
      value: "answerer",
      defaultColor: "fd7e14",
    },
    {
      label: lang.components.status_selector.statuses.to_call,
      value: "to_call",
      defaultColor: "be4bdb",
    },
    {
      label: lang.components.status_selector.statuses.out_of_office,
      value: "out_of_office",
      defaultColor: "000000",
    },
  ];
};

export const defaultStatusColors = {
  opener: "4c6ef5",
  clicker: "fab005",
  answerer: "fd7e14",
  to_call: "be4bdb",
  out_of_office: "000000",
  answerer_positive: "12b886",
  answerer_negative: "fa2a2a",
};

export function get_positive_label() {
  const lang = useLanguage.getState().language;
  return [
    { label: lang.prm.positive, value: "1" },
    { label: lang.prm.negative, value: "0" },
    { label: lang.prm.neutral, value: "null" },
  ];
}

export function getEmailsLink() {
  const model_emails = useModelsStore.getState().model_emails;
  const email_signatures = useConfigStore.getState().email_signatures;
  return [
    ...new Set(
      [...model_emails, email_signatures].flatMap((x) => x?.links || []),
    ),
  ];
}

export function setupFilters({ datafields = [], custom_columns }) {
  const lang = useLanguage.getState().language;

  let result = [
    {
      label: "Specials",
      options: [
        {
          option_name: "ID prospect",
          type: "text",
          id: "id",
          filterable: true,
          field: "id",
        },
        {
          option_name: lang.prm.filter_labels.status,
          type: "boolean",
          options: status_list(),
          id: "status",
          filterable: true,
          field: "status",
        },
        {
          option_name: lang.prm.filter_labels.custom_status,
          options: custom_columns,
          id: "custom_status",
          filterable: true,
          field: "custom_status",
        },
        {
          option_name: lang.prm.filter_labels.new_reply,
          type: "boolean",
          id: "new_reply",
          options: [
            {
              label: lang.global.yes,
              value: "1",
            },
            {
              label: lang.global.no,
              value: "0",
            },
          ],
          filterable: true,
          field: "new_reply",
          disabledCondition: true,
        },
        {
          option_name: lang.prm.filter_labels.new_first_reply,
          type: "boolean",
          id: "new_first_reply",
          options: [
            {
              label: lang.global.yes,
              value: "1",
            },
            {
              label: lang.global.no,
              value: "0",
            },
          ],
          filterable: true,
          field: "new_first_reply",
          disabledCondition: true,
        },
        {
          option_name: lang.prm.filter_labels.click_count,
          type: "number",
          id: "click_count",
          filterable: true,
          field: "click_count",
          noExists: true,
        },
        {
          option_name: lang.prm.filter_labels.email_open_count,
          type: "number",
          id: "email_open_count",
          filterable: true,
          field: "email_open_count",
          noExists: true,
        },
        {
          option_name: lang.prm.filter_labels.contacted_email,
          type: "boolean",
          id: "contacted_email",
          options: [
            {
              label: lang.global.yes,
              value: "1",
            },
            {
              label: lang.global.no,
              value: "0",
            },
          ],
          filterable: true,
          field: "contacted_email",
          disabledCondition: true,
        },
        {
          option_name: lang.prm.filter_labels.contacted_linkedin,
          type: "boolean",
          id: "contacted_linkedin",
          options: [
            {
              label: lang.global.yes,
              value: "1",
            },
            {
              label: lang.global.no,
              value: "0",
            },
          ],
          filterable: true,
          field: "contacted_linkedin",
          disabledCondition: true,
        },
        {
          option_name: lang.prm.filter_labels.in_active_programmation,
          type: "boolean",
          id: "in_active_programmation",
          options: [
            {
              label: lang.prm.filter_labels.in_active_programmation_yes,
              value: "1",
            },
            {
              label: lang.prm.filter_labels.in_active_programmation_no,
              value: "0",
            },
          ],
          filterable: true,
          field: "in_active_programmation",
          disabledCondition: true,
        },
        {
          option_name: lang.prm.filter_labels.score,
          type: "number",
          id: "score",
          filterable: true,
          field: "score",
        },
        {
          option_name: lang.prm.filter_labels.campaign,
          type: "lazy",
          id: "programmation_id",
          options: [],
          filterable: true,
          field: "programmation_id",
          getter: getQuickCampaigns,
          responseField: "results",
          storeKey: "campaignOptions",
          setStoreKey: "setCampaignOptions",
          nameField: "workflow_name",
        },
        {
          option_name: lang.prm.filter_labels.status_change,
          type: "leads_status",
          id: "status_change_count",
          options: [],
          filterable: true,
          field: "status_change_count",
          disabledCondition: false,
          noExists: true,
        },
        {
          option_name: lang.prm.filter_labels.status_from_programmation,
          type: "campaign",
          id: "status_from_programmation",
          options: [],
          filterable: true,
          field: "status_from_programmation",
          disabledCondition: true,
        },
        {
          option_name: lang.prm.filter_labels.contact_list,
          type: "lazy",
          id: "contact_list_id",
          options: [],
          filterable: true,
          field: "contact_list_id",
          getter: getLists,
          responseField: "contact_lists",
          storeKey: "listOptions",
          setStoreKey: "setListOptions",
          nameField: "name",
          disabledCondition: true,
        },
        {
          option_name: lang.prm.filter_labels.workflow,
          type: "lazy",
          id: "workflow_id",
          options: [],
          filterable: true,
          field: "workflow_id",
          getter: getWorkflows,
          responseField: "workflows",
          storeKey: "workflowOptions",
          setStoreKey: "setWorkflowOptions",
          nameField: "name",
          disabledCondition: true,
        },
        {
          option_name: lang.prm.filter_labels.opener_step,
          type: "number",
          id: "opener_step",
          filterable: true,
          field: "opener_step",
          disabledCondition: true,
        },
        {
          option_name: lang.prm.filter_labels.clicker_step,
          type: "number",
          id: "clicker_step",
          filterable: true,
          field: "clicker_step",
          disabledCondition: true,
        },
        {
          option_name: lang.prm.filter_labels.answerer_step,
          type: "number",
          id: "answerer_step",
          filterable: true,
          field: "answerer_step",
          disabledCondition: true,
        },
        {
          option_name: lang.prm.filter_labels.integration,
          type: "lazy",
          id: "integration_id",
          options: [],
          filterable: true,
          field: "integration_id",
          groups: [
            {
              name: lang.prm.filter_labels.linkedin_account,
              getter: getLinkedinAccounts,
              responseField: "linkedin_accounts_list",
            },
            {
              name: lang.prm.filter_labels.email_account,
              getter: getEmails,
              responseField: "email_accounts_list",
            },
          ],
          storeKey: "integrationOptions",
          setStoreKey: "setIntegrationOptions",
          nameField: "name",
          disabledCondition: true,
        },
        {
          option_name: lang.prm.filter_labels.call_created_by,
          type: "lazy",
          id: "call_created_by",
          options: [],
          filterable: true,
          field: "call_created_by",
          getter: async () =>
            getFirstPageUsers({ per_page: 100 }).then((response) => {
              let self = useProfileStore.getState().profile;
              return {
                data: {
                  users: [self, ...response.data.results].map((x) => ({
                    name: `${x.first_name} ${x.last_name}`,
                    id: x.id,
                  })),
                },
              };
            }),
          responseField: "users",
          storeKey: "usersOptions",
          setStoreKey: "setUsersOptions",
          nameField: "name",
          disabledCondition: true,
        },
        {
          option_name: lang.prm.filter_labels.person_in_charge,
          type: "lazy",
          id: "person_in_charge",
          options: [],
          filterable: true,
          field: "person_in_charge",
          getter: async () =>
            getFirstPageUsers({ per_page: 100 }).then((response) => {
              let self = useProfileStore.getState().profile;
              return {
                data: {
                  users: [self, ...response.data.results].map((x) => ({
                    name: `${x.first_name} ${x.last_name}`,
                    id: x.id,
                  })),
                },
              };
            }),
          responseField: "users",
          storeKey: "usersOptions",
          setStoreKey: "setUsersOptions",
          nameField: "name",
          disabledCondition: true,
        },
        {
          option_name: lang.prm.filter_labels.company_has_person_in_charge,
          type: "boolean",
          id: "company_has_person_in_charge",
          options: [
            {
              label:
                lang.table.toolbar.filter.filters_list_label.server
                  .has_person_in_charge,
              value: "1",
            },
            {
              label:
                lang.table.toolbar.filter.filters_list_label.server
                  .has_no_person_in_charge,
              value: "0",
            },
          ],
          filterable: true,
          field: "company_has_person_in_charge",
          nameField: "name",
          disabledCondition: true,
        },
        {
          option_name: lang.prm.filter_labels.phone_has_person_in_charge,
          type: "boolean",
          id: "phone_has_person_in_charge",
          options: [
            {
              label:
                lang.table.toolbar.filter.filters_list_label.server
                  .has_person_in_charge,
              value: "1",
            },
            {
              label:
                lang.table.toolbar.filter.filters_list_label.server
                  .has_no_person_in_charge,
              value: "0",
            },
          ],
          filterable: true,
          field: "phone_has_person_in_charge ",
          nameField: "name",
          disabledCondition: true,
        },
        {
          option_name: lang.prm.filter_labels.link_click,
          type: "boolean",
          options: getEmailsLink(),
          id: "link_click",
          filterable: true,
          field: "link_click",
          withCustomOption: true,
          disabledCondition: true,
        },
        {
          option_name: lang.prm.filter_labels.is_positive,
          type: "boolean",
          id: "is_positive",
          options: get_positive_label(),
          filterable: true,
          field: "is_positive",
        },
        {
          option_name: "Tag",
          type: "lazy",
          id: "tag_id",
          options: [],
          filterable: true,
          field: "tag_id",
          getter: getTags,
          responseField: "tags_list",
          storeKey: "tagOptions",
          setStoreKey: "setTagOptions",
          nameField: "name",
          conditions: [
            {
              value: "equals",
              label: lang.table.toolbar.filter.filters_list_label.server.equals,
            },
            {
              value: "not_equals",
              label:
                lang.table.toolbar.filter.filters_list_label.server.not_equals,
            },
            {
              value: "contains",
              label:
                lang.table.toolbar.filter.filters_list_label.server.contains,
            },
            {
              value: "not_contains",
              label:
                lang.table.toolbar.filter.filters_list_label.server
                  .not_contains,
            },
            {
              value: "does_not_exist",
              label:
                lang.table.toolbar.filter.filters_list_label.server
                  .does_not_exist,
            },
            {
              value: "does_exist",
              label:
                lang.table.toolbar.filter.filters_list_label.server.does_exist,
            },
          ],
        },
        {
          option_name: lang.prm.filter_labels.notes,
          type: "contain",
          id: "notes",
          filterable: true,
          field: "notes",
        },
      ],
    },
    {
      label: lang.forms.fields,
      options: [
        ...(datafields?.map((field) => ({
          option_name: field.name,
          type: "text",
          id: field.id,
          filterable: true,
          field: field.identifier_placeholder,
        })) || []),
      ],
    },
    {
      label: "Dates",
      options: [
        {
          option_name: lang.prm.filter_labels.last_call,
          type: "date",
          id: "last_call",
          filterable: true,
          field: "last_call",
        },
        {
          option_name: lang.prm.filter_labels.last_note_date,
          type: "date",
          id: "last_note_date",
          filterable: true,
          field: "last_note_date",
        },
        {
          option_name: lang.prm.filter_labels.created_on,
          type: "date",
          id: "created_on",
          filterable: true,
          field: "created_on",
        },
        {
          option_name: lang.prm.filter_labels.last_reply,
          type: "date",
          id: "last_reply",
          filterable: true,
          field: "last_reply",
        },
        {
          option_name: lang.prm.filter_labels.status_changed_date,
          type: "date",
          id: "status_changed_date",
          filterable: true,
          field: "status_changed_date",
        },
        {
          option_name: lang.prm.filter_labels.last_link_click,
          type: "date",
          id: "last_link_click",
          filterable: true,
          field: "last_link_click",
        },
        {
          option_name: lang.prm.filter_labels.last_email_open,
          type: "date",
          id: "last_email_open",
          filterable: true,
          field: "last_email_open",
        },
        {
          option_name: lang.prm.filter_labels.last_email_answered,
          type: "date",
          id: "last_email_answered",
          filterable: true,
          field: "last_email_answered",
        },
        {
          option_name: lang.prm.filter_labels.last_linkedin_invitation_accepted,
          type: "date",
          id: "last_linkedin_invitation_accepted",
          filterable: true,
          field: "last_linkedin_invitation_accepted",
        },
        {
          option_name: lang.prm.filter_labels.last_linkedin_message_answered,
          type: "date",
          id: "last_linkedin_message_answered",
          filterable: true,
          field: "last_linkedin_message_answered",
        },
        {
          option_name: lang.prm.filter_labels.last_sms_got,
          type: "date",
          id: "last_sms_got",
          filterable: true,
          field: "last_sms_got",
        },
        {
          option_name: lang.prm.filter_labels.last_sms_not_got,
          type: "date",
          id: "last_sms_not_got",
          filterable: true,
          field: "last_sms_not_got",
        },
      ],
    },
  ];

  useLeadsStore.getState().setFilters(result);
}

export const callColors = {
  phone: "#dd9409",
  phone_away: "#ce0f0f",
  email: "#ffcb10",
  visio: "#2ba97b",
  meeting: "#cd6c54",
  appointment: "#000",
};

export const reminderTypes = () => {
  const lang = useLanguage.getState().language;

  return {
    phone: lang.prm.details.reminders.types.phone,
    phone_away: lang.prm.details.reminders.types.phone_away,
    email: lang.prm.details.reminders.types.email,
    visio: lang.prm.details.reminders.types.visio,
    meeting: lang.prm.details.reminders.types.meeting,
    appointment: lang.prm.details.reminders.types.appointment,
    other: lang.prm.details.reminders.types.other,
  };
};

export function getDifference(date) {
  const now = dayjs();
  const target = dayjs(date);

  const result = target.diff(now, "m");
  const days = Math.floor(result / (60 * 24));
  const hours = Math.floor((result % (60 * 24)) / 60);
  const minutes = result % 60;

  return {
    result: result,
    days,
    hours,
    minutes,
  };
}

export function formatAnswer(answer) {
  if (window.innerWidth < 768) {
    return `<div style="font-family: sans-serif;font-size:14px;" > ${answer} </div>`;
  }
  return `<div style="font-family: sans-serif;" > ${answer} </div>`;
}

export function parseProspectDatafields(prospect) {
  let newProspect = { ...prospect };
  const datafields = useConfigStore.getState().datafields;

  let defaultResults = datafields
    // .filter((x) => x.created_by === null)
    .map((element) => {
      let value = newProspect.properties.find(
        (x) =>
          x?.data_field_id === element.id ||
          x?.identifier_placeholder === element.identifier_placeholder,
      )?.value;

      return {
        identifier_placeholder: element.identifier_placeholder,
        id: element.id,
        name: element.name,
        value: value,
      };
    });

  newProspect.properties = defaultResults;

  newProspect.fromContactList = newProspect?.programmations?.find(
    (x) => !!x?.contact_list_id,
  )?.contact_list_id;
  newProspect.programmations = newProspect?.programmations?.filter(
    (x) => !!x.programmation_id,
  );

  return newProspect;
}

const bioList = [
  { key: "%last_name%", value: "lastName" },
  { key: "%first_name%", value: "firstName" },
  { key: "%job_title%", value: "jobTitle" },
  { key: "%company%", value: "company" },
  { key: "%email%", value: "email" },
  { key: "%linkedin_url%", value: "linkedin_url" },
];
export function getProspectBio(prospect) {
  let result = {};
  bioList.forEach((item) => {
    result[item.value] =
      prospect?.properties?.find((x) => x.identifier_placeholder === item.key)
        ?.value || " - ";
  });

  return result;
}

export const groupByMonthAndProgId = (groups, noProgs) => {
  const result = [];
  const temp = {};

  groups.forEach((group) => {
    const groupID = group.programmation_id;

    group?.items?.forEach((item) => {
      // Extract the year and month part (YYYY-MM)
      const month = item.date.slice(0, 7);
      const key = `${month}_${groupID}`;

      // If this key doesn't exist in temp, initialize it
      if (!temp[key]) {
        temp[key] = { month, replies: [], ...group };
        result.push(temp[key]); // Add to result array
      }

      // Push the item into the corresponding month-group array
      temp[key].replies.push(item);
    });
  });

  // Sort items in each group by date (oldest to newest)
  result.forEach((group) => {
    group.replies.sort((a, b) => new Date(b.date) - new Date(a.date));

    // Check for multiple unique days
    const uniqueDays = new Set(
      group.replies.map((item) => item.date.slice(0, 10)),
    );
    group.hasMultipleDays = uniqueDays.size > 1;
  });

  result.sort((a, b) => {
    const aLatestDate = new Date(a.replies[0]?.date || 0); // Fallback to 0 if no replies
    const bLatestDate = new Date(b.replies[0]?.date || 0);
    return bLatestDate - aLatestDate; // oldest to newest
  });

  return result;
};

export function getCallColor(call_date, inTable) {
  let status = getDateStatus(call_date);
  if (status === "past") {
    return "var(--mantine-color-orange-8)";
  }
  if (status === "future") {
    return "var(--mantine-color-green-8)";
  }
  if (inTable) {
    return "var(--mantine-color-primary-6)";
  }
  return "var(--mantine-color-red-8)";
}

export function deselectAll() {
  const setSelectedColumns =
    useLeadsContainerStore.getState().setSelectedColumns;
  const setSelectedIds = useLeadsContainerStore.getState().setSelectedIds;
  const setUnselectedIds = useLeadsContainerStore.getState().setUnselectedIds;

  setSelectedColumns([]);
  setSelectedIds([]);
  setUnselectedIds([]);
}

export function getCcAsArray(messageContent) {
  // 1. On cherche la ligne qui commence par "Cc:" jusqu'au prochain <br>
  const ccMatch = messageContent.match(/Cc:\s*(.*?)<br>/i);

  if (ccMatch && ccMatch[1]) {
    // 2. On sépare par la virgule et on nettoie les espaces
    return ccMatch[1].split(",").map((email) => email.trim());
  }

  return []; // Retourne un tableau vide si aucun Cc n'est trouvé
}

export function getSelected() {
  const containers = useLeadsContainerStore.getState().containers;
  const selectedColumns = useLeadsContainerStore.getState().selectedColumns;
  const selectedIds = useLeadsContainerStore.getState().selectedIds;
  const unselectedIds = useLeadsContainerStore.getState().unselectedIds;
  let final = 0;
  containers.forEach((container) => {
    if (selectedColumns.includes(container.id)) {
      let total_col = container.total;
      let total_unselected = unselectedIds[container.id]?.length || 0;

      final += total_col - total_unselected;
    } else {
      final += selectedIds[container.id]?.length || 0;
    }
  });

  return final;
}
